import axios from "axios";
import Config from "../utils/Config";

class ClientService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_agt_tk")}`,
      },
    };
  }

  async createClient(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/create/client`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Client created successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while creating client",
        data: null,
        validationErrors: error.response?.data?.errors || error.response?.data?.validationErrors || null,
      };
    }
  }

  async createStudent(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/create/student`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || "Student registered successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while registering student",
        data: null,
        validationErrors: error.response?.data?.errors || error.response?.data?.validationErrors || null,
      };
    }
  }

  async getStudents() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/agent/get/all/students`,
        this.getAuthHeaders()
      );
      const body = response.data?.data;
      const raw = body?.data;
      const list = Array.isArray(raw)
        ? raw
        : raw && typeof raw === "object"
          ? Object.values(raw)
          : [];
      return {
        status: body?.status_code === 200,
        message: body?.reason || body?.message || "Students fetched successfully",
        data: list,
      };
    } catch (error) {
      const errData = error.response?.data?.data;
      return {
        status: false,
        message:
          errData?.reason || errData?.message || error.response?.data?.message ||
          "An error occurred while fetching students",
        data: [],
      };
    }
  }

  async getClients() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/agent/registered/clients`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: "Clients fetched successfully",
        data: response.data?.data || [],
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while fetching clients",
        data: [],
      };
    }
  }

  async updateClient(clientSlug, payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/update/registered_client/${clientSlug}`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || response.data.message || "Client updated successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while updating client",
        data: null,
        validationErrors: error.response?.data?.errors || error.response?.data?.validationErrors || null,
      };
    }
  }

  async updateStudent(studentSlug, payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/agent/update/student/${studentSlug}`,
        payload,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message: response.data.data?.reason || response.data.message || "Student updated successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while updating student",
        data: null,
        validationErrors: error.response?.data?.errors || error.response?.data?.validationErrors || null,
      };
    }
  }

  async verifyRegisteredClient(clientSlug) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/agent/verify/registered_client/${clientSlug}`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        message:
          response.data?.data?.reason ||
          response.data?.message ||
          "Client verification status updated successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "An error occurred while updating client verification status",
        data: null,
      };
    }
  }
}

const clientService = new ClientService();
export default clientService;
